import { fansupportPublic } from "./index";

export const getCountry = async ({ sportId }) => {
    return fansupportPublic.get('/sport/filter', {params: {
        sportId,
    }})
}